import { CivilStatusAuthorizations } from './civil-status';

export enum FrontOfficeAuthorizations {
  UfficioCassa = 'CERTIFICAZIONE.CASSA.UFFCASSA',
  FrontOfficeQuery = 'SPORTELLO.CERTIFICAZIONE.ANPR',
  CertificatoUpdate = 'CERTIFICATO.ANPR.UPDATE',
  CertificatoQuery = 'CERTIFICATO.ANPR.QUERY',
  CertificatoDelete = 'CERTIFICATO.ANPR.DELETE',
  CertificazioneRegistroQuery = 'CERTIFICAZIONE.REGISTRO.QUERY',
  CertificazioneRegistroAdd = 'CERTIFICAZIONE.REGISTRO.ADD',
  CertificazioneRegistroUpdate = 'CERTIFICAZIONE.REGISTRO.UPDATE',
  CertificazioneRegistroDelete = 'CERTIFICAZIONE.REGISTRO.DELETE',
  TipoDocQuery = 'CERTIFICAZIONE.TIPODOC.QUERY',
  TipoDocUpdate = 'CERTIFICAZIONE.TIPODOC.UPDATE',
  TipoDocDelete = 'CERTIFICAZIONE.TIPODOC.DELETE',
  TipoDocAdd = 'CERTIFICAZIONE.TIPODOC.ADD',
  Attestazione = 'SPORTELLO.CERTIFICAZIONE.ATTESTAZIONI',
  Autentiche = 'SPORTELLO.CERTIFICAZIONE.AUTENTICHE',
  Dichiarazioni = 'SPORTELLO.CERTIFICAZIONE.DICHIARAZIONI',
  Storiche = 'SPORTELLO.CERTIFICAZIONE.STORICA',
  Elettorale = 'SPORTELLO.CERTIFICAZIONE.ELETTORALE',
  ElettoraleAnpr = 'SPORTELLO.CERTIFICAZIONE.ELETTORALE.ANPR',
  TesseraElettorale = 'SPORTELLO.DOCUMENTI.TESSERA.ELETT',
  Leva = 'SPORTELLO.CERTIFICAZIONE.LEVA',
  TipoRilascioQuery = 'CERTIFICAZIONE.TIPORILASCIO.QUERY',
  TipoRilascioAdd = 'CERTIFICAZIONE.TIPORILASCIO.ADD',
  TipoRilascioUpdate = 'CERTIFICAZIONE.TIPORILASCIO.UPDATE',
  TipoRilascioDelete = 'CERTIFICAZIONE.TIPORILASCIO.DELETE',
  DocumentiPDS = 'SPORTELLO.DOCUMENTI.PDS',
  StampaRicevutaPos = 'SPORTELLO.CERTIFICAZIONE.RIC.POS',
  RegistrazioneCarta = 'DOCUMENTI.REGISTRAZIONE.CARTA',
  AnnullamentoCarta = 'DOCUMENTI.ANNULLAMENTO.CARTA',
  RicercaLotti = 'SPORTELLO.DOCUMENTI.LOTTI.INQ',
  ModificaLotti = 'SPORTELLO.DOCUMENTI.LOTTI.UPD',
  RistampaCID = 'DOCUMENTI.RISTAMPA.CARTA',
  RicercaImporto = 'CERTIFICAZIONE.IMPORTO.QUERY',
  NuovoImporto = 'CERTIFICAZIONE.IMPORTO.ADD',
  ModificaImporto = 'CERTIFICAZIONE.IMPORTO.UPDATE',
  EliminaImporto = 'CERTIFICAZIONE.IMPORTO.DELETE',
  TabelleElettorale = 'SPORTELLO.TESSERA.ELETTORALE.QUERY',
  RecuperoCartelliniCie = 'IMMAGINE.CARTELLINI.CARICAMENTO',
  StampaAutorizzazioneVoto = 'SPORTELLO.DOCUMENTI.CERTIF.AUTORIZZAZIONE',
}

export const CertificationAuthorizations = [FrontOfficeAuthorizations.FrontOfficeQuery];

export const ClaimsAuthorizations = [FrontOfficeAuthorizations.Attestazione];

export const AuthenticAuthorizations = [FrontOfficeAuthorizations.Autentiche];

export const StatementsAuthorizations = [FrontOfficeAuthorizations.Dichiarazioni];

export const HistoricalAuthorizations = [FrontOfficeAuthorizations.Storiche];

export const LeverAuthorizations = [FrontOfficeAuthorizations.Leva];

export const ElectoralAuthorizations = [FrontOfficeAuthorizations.Elettorale];

export const ElectoralCardAuthorizations = [FrontOfficeAuthorizations.TesseraElettorale];

export const RetrieveIdCardAuthorizations = [FrontOfficeAuthorizations.RecuperoCartelliniCie];

export const CashCheckAuthorization = [
  FrontOfficeAuthorizations.CertificatoQuery,
  FrontOfficeAuthorizations.CertificatoUpdate,
];

export const ResidencyPermitAuthorizations = [FrontOfficeAuthorizations.DocumentiPDS];

export const RegisterCertificationAuthorizations = [
  FrontOfficeAuthorizations.CertificazioneRegistroQuery,
  FrontOfficeAuthorizations.CertificazioneRegistroAdd,
  FrontOfficeAuthorizations.CertificazioneRegistroDelete,
  FrontOfficeAuthorizations.CertificazioneRegistroUpdate,
];

export const TypeDocAuthorizations = [
  FrontOfficeAuthorizations.TipoDocQuery,
  FrontOfficeAuthorizations.TipoDocUpdate,
  FrontOfficeAuthorizations.TipoDocDelete,
  FrontOfficeAuthorizations.TipoDocAdd,
];

export const ReleaseModeAuthorizations = [
  FrontOfficeAuthorizations.TipoRilascioQuery,
  FrontOfficeAuthorizations.TipoRilascioAdd,
  FrontOfficeAuthorizations.TipoRilascioUpdate,
  FrontOfficeAuthorizations.TipoRilascioDelete,
];

export const PrintReceiptPosAuthorizations = [FrontOfficeAuthorizations.StampaRicevutaPos];

export const ElectoralCardTableAuthorizations = [FrontOfficeAuthorizations.TabelleElettorale];

export const RegistrationIDCardAuthorizations = [FrontOfficeAuthorizations.RegistrazioneCarta];

export const AnnullamentIDCardAuthorizations = [FrontOfficeAuthorizations.AnnullamentoCarta];

export const ReleaseIdCardAuthorizations = [FrontOfficeAuthorizations.RegistrazioneCarta];

export const CashManagementAuthorizations = [FrontOfficeAuthorizations.UfficioCassa];

export const LotsManagementAuthorizations = [
  FrontOfficeAuthorizations.RicercaLotti,
  FrontOfficeAuthorizations.ModificaLotti,
];

export const ReprintCidAuthorizations = [FrontOfficeAuthorizations.RistampaCID];

export const AmountAuthorizations = [
  FrontOfficeAuthorizations.RicercaImporto,
  FrontOfficeAuthorizations.ModificaImporto,
  FrontOfficeAuthorizations.EliminaImporto,
  FrontOfficeAuthorizations.NuovoImporto,
];

export const FrontOfficeAuthorizationsList = [
  ...CertificationAuthorizations,
  ...RegisterCertificationAuthorizations,
  ...TypeDocAuthorizations,
  ...ClaimsAuthorizations,
  ...AuthenticAuthorizations,
  ...StatementsAuthorizations,
  ...HistoricalAuthorizations,
  ...ReleaseModeAuthorizations,
  ...CashManagementAuthorizations,
  ...CashCheckAuthorization,
  ...ResidencyPermitAuthorizations,
  ...PrintReceiptPosAuthorizations,
  ...RegistrationIDCardAuthorizations,
  ...AnnullamentIDCardAuthorizations,
  ...ReleaseIdCardAuthorizations,
  ...LotsManagementAuthorizations,
  ...ReprintCidAuthorizations,
  ...AmountAuthorizations,
  ...ElectoralCardTableAuthorizations,
  ...LeverAuthorizations,
  ...ElectoralAuthorizations,
  ...RetrieveIdCardAuthorizations,
  ...ElectoralAuthorizations,
  ...[CivilStatusAuthorizations.StampaCertificazione],
  ...[FrontOfficeAuthorizations.ElettoraleAnpr],
  ...[FrontOfficeAuthorizations.StampaAutorizzazioneVoto],
];
